import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyEditPayment = lazyWithRetry(() => import("./EditPayment"));

const EditPayment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyEditPayment {...props} />;

export default EditPayment;
